import { GA_4_TRACKING_ID } from '@/lib/constants';

export const sendEventGA = (event: string, action: string, data: any): void => {
  if (GA_4_TRACKING_ID) {
    //@ts-expect-error
    window.gtag(event, action, data);
  }
};
